import { Badge } from 'antd'
import { observer } from 'mobx-react-lite'

import { classNames } from '@/Ship/Helpers/classNames'
import { counterManager } from '@/Ship/Stores/CounterManager'

import type { ReactNode } from 'react'

import styles from './MenuBadge.module.css'

/** Понад скільки бейдж пише «99+» — як у легасі (`Menu.jsx:21-26`). */
export const MENU_BADGE_OVERFLOW = 99

interface MenuBadgeLabelProps {
    /** Код лічильника з `GET /services/counters`: `activity`. */
    counter: string
    /** Підпис пункту: «Справи». */
    children: ReactNode
}

/**
 * Підпис пункту бокового меню з лічильником (ADR 030, `SPEC-014` §3.2):
 * «Справи» і праворуч — скільки справ прострочено. Нуль не показується,
 * понад 99 — «99+». Число оновлюється без перезавантаження: його рухає подія
 * `counters` з Centrifugo (`CounterManager`).
 */
export const MenuBadgeLabel = observer(({ counter, children }: MenuBadgeLabelProps) => {
    const count = counterManager.value(counter)

    return (
        <span className={classNames(styles['label'])} data-counter={counter}>
            <span className={classNames(styles['text'])}>{children}</span>
            <Badge count={count} overflowCount={MENU_BADGE_OVERFLOW} size="small" />
        </span>
    )
})

MenuBadgeLabel.displayName = 'MenuBadgeLabel'
